/*
 * Resets assignment fields below the field that was (re)selected
 */
export default (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    const categories = payload.customData.categories;
    const ids = [];
    for (let i = 0; i < categories.length; i++) {
        setAttribute(context, `${moduleId}_${categories[i]}`, 'value', '');
        setAttribute(context, `${moduleId}_${categories[i]}-collapse`, 'visible', false);
        context.commit('SET_PATH_PARAM', {
            key: categories[i],
            value: null,
        });

        ids.push(`${moduleId}_${categories[i]}`);
    }

    context.commit('REMOVE_TRACKED_ERRORS', ids);
};